'use client';

import { Product } from 'shared/types/product/Product';
import { DataSource } from 'types/datasource';
import { TasticProps } from 'frontastic/tastics/types';
import InstantSearch from 'components/HOC/InstantSearch';
import LocalizedIndex from 'providers/algolia/localized-index';
import ProductSliderAlgolia, {
  ProductSliderProps,
} from 'components/commercetools-ui/organisms/product/product-slider-algolia';
import { useSearchParams } from 'next/navigation';
import { useProduct } from 'frontastic/hooks';
import { useEffect, useState } from 'react';

function ProductSliderAlgoliaTastic({
  data,
}: TasticProps<DataSource<{ items: Product[]; categoryToFetch: string; parentProductId: string }> & ProductSliderProps>) {
  //eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { mobile, tablet, desktop, ...props } = data;
  const { getRelatedProducts } = useProduct();
  const [relatedProducts, setRelatedProducts ] =useState([]) 
  const payload = data?.data?.dataSource;

  useEffect(() => {
    const fetchRelatedProducts = async () => {
      const relProducts = await getRelatedProducts(payload);
      setRelatedProducts(relProducts?.items);
    };
    fetchRelatedProducts()
  }, []);

  const searchParams = useSearchParams();
  const isFromBim = (searchParams.get('fromBim') as string) === 'true';
  if (isFromBim) {
    return null;
  }

  return (
    <InstantSearch>
      <LocalizedIndex type="products">
        <ProductSliderAlgolia
          {...props}
          categoryToFetch={data?.data?.dataSource?.categoryToFetch}
          parentProductId={data?.data?.dataSource?.parentProductId}
          products={relatedProducts ?? []}
        />
      </LocalizedIndex>
    </InstantSearch>
  );
}

export default ProductSliderAlgoliaTastic;
